import React from 'react';

export default function Terms() {
  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow">
        <div className="max-w-4xl mx-auto px-6 py-4">
          <h1 className="text-xl font-bold text-gray-800">PayrollDesk</h1>
        </div>
      </nav>

      <div className="max-w-4xl mx-auto px-6 py-10 bg-white shadow-sm mt-6 rounded-lg">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Terms and Conditions</h1>
        <p className="text-sm text-gray-500 mb-8">Last updated: April 14, 2026</p>

        <section className="space-y-6 text-gray-700">
          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">1. Agreement to Terms</h2>
            <p>These Terms and Conditions govern your use of the PayrollDesk support ticketing system
            (the "Service") provided by Alder Holdings LLC ("we", "us", or "our"). By accessing
            or using the Service, you agree to be bound by these terms.</p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">2. Description of Service</h2>
            <p>PayrollDesk is an internal support ticketing system used by Alder Holdings LLC and
            its representatives to submit, track, and resolve payroll-related issues. Submissions
            may be made through the web dashboard, email to help@alderpayroll.com, or text message
            to our designated support phone numbers.</p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">3. SMS Opt-In and Messaging Terms</h2>
            <p><strong>Opt-In / Consent:</strong> By sending a text message to our support phone number,
            you are expressly opting in and providing your consent to receive SMS messages from
            PayrollDesk (operated by Alder Holdings LLC). These messages include ticket confirmations,
            status updates, agent replies, and resolution notifications related to your support request.
            Your initial text message to our number constitutes your opt-in consent.</p>
            <p className="mt-2"><strong>Message Frequency:</strong> Message frequency varies based on
            your active support requests. You will only receive messages directly related to
            support tickets you have initiated.</p>
            <p className="mt-2"><strong>Message & Data Rates:</strong> Message and data rates may apply
            depending on your mobile carrier and plan. Alder Holdings LLC is not responsible
            for any charges from your carrier.</p>
            <p className="mt-2"><strong>Opt-Out:</strong> You may opt out and revoke your consent at any time by replying
            <strong> STOP</strong>, <strong>UNSUBSCRIBE</strong>, <strong>END</strong>, <strong>QUIT</strong>,
            or <strong>CANCEL</strong> to any message. After opting out, you will receive a single
            confirmation message and no further SMS messages will be sent. You may opt back in
            at any time by texting <strong>START</strong> to our support number.</p>
            <p className="mt-2"><strong>Help:</strong> Reply <strong>HELP</strong> for assistance or
            contact us at <a href="mailto:help@alderpayroll.com" className="text-blue-600 hover:underline">help@alderpayroll.com</a>.</p>
            <p className="mt-2"><strong>Supported Carriers:</strong> Compatible with all major US carriers
            including AT&T, T-Mobile, Verizon, and others.</p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">4. Acceptable Use</h2>
            <p>You agree to use the Service only for legitimate payroll support purposes. You will not:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Submit false, misleading, or fraudulent information</li>
              <li>Attempt to gain unauthorized access to the system or other users' tickets</li>
              <li>Use the Service to transmit harmful code, spam, or unsolicited content</li>
              <li>Interfere with or disrupt the operation of the Service</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">5. Account Security</h2>
            <p>If you are issued login credentials for the dashboard, you are responsible for
            maintaining the confidentiality of your credentials and all activity that occurs
            under your account. Notify us immediately of any unauthorized use.</p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">6. Data and Privacy</h2>
            <p>Information submitted through the Service is used solely to resolve your support
            request and maintain records of the interaction. Our data handling practices are
            described in our Privacy Policy.</p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">7. Attachments and Submitted Content</h2>
            <p>You may attach files to your support requests. By doing so, you represent that you
            have the right to share such content and that it does not contain confidential,
            sensitive, or personally identifiable information about third parties beyond what
            is necessary to resolve your issue.</p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">8. Service Availability</h2>
            <p>We strive to maintain continuous availability of the Service but do not guarantee
            uninterrupted access. The Service may be temporarily unavailable due to maintenance,
            updates, or circumstances beyond our control.</p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">9. Limitation of Liability</h2>
            <p>The Service is provided "as is" without warranties of any kind. To the fullest extent
            permitted by law, Alder Holdings LLC shall not be liable for any indirect, incidental,
            consequential, or punitive damages arising from your use of the Service.</p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">10. Modifications</h2>
            <p>We reserve the right to update these Terms at any time. Changes will be posted on
            this page with an updated "Last updated" date. Continued use of the Service after
            changes constitutes acceptance of the revised Terms.</p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">11. Contact</h2>
            <p>For questions about these Terms, contact us at <a href="mailto:help@alderpayroll.com" className="text-blue-600 hover:underline">help@alderpayroll.com</a>.</p>
          </div>
        </section>

        <footer className="mt-12 pt-6 border-t text-sm text-gray-500 text-center">
          &copy; 2026 Alder Holdings LLC. All rights reserved.
        </footer>
      </div>
    </div>
  );
}
